var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 107.2992125984252 108.38845144356955",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l107.29921 0l0 108.38845l-107.29921 0l0 -108.38845z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l107.29921 0l0 108.38845l-107.29921 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m4.6639004 92.36755c5.079273 -10.666626 23.686134 -56.41824 30.475637 -63.999756c6.789501 -7.5815163 5.3898697 20.630537 10.261372 18.510656c4.8715057 -2.1198769 9.882061 -38.923058 18.967644 -31.229923c9.085587 7.6931334 29.621567 64.49061 35.545876 77.388725",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m4.6639004 92.36755c5.079273 -10.666626 23.686134 -56.41824 30.475637 -63.999756c6.789501 -7.5815163 5.3898697 20.630537 10.261372 18.510656c4.8715057 -2.1198769 9.882061 -38.923058 18.967644 -31.229923c9.085587 7.6931334 29.621567 64.49061 35.545876 77.388725",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.58f35d13b951e2e38b12bd3c7d247f3b.svg";
export { ForwardRef as ReactComponent };